import React from 'react'
import Slider from 'react-slick'
import { makeStyles, CircularProgress } from '@material-ui/core'
import moment from 'moment'

const useStyles = makeStyles(theme => ({
  slider_root: {
    marginTop: 24,
    minHeight: 430,
    overflow: 'hidden',
    '& .slick-slide': {
      padding: '0px 10px'
    },
    '& .slick-list': {
      margin: '0px -10px'
    },
    '& .slick-dots': {
      bottom: '-20px'
    }
  },
  title: {
    color: '#386093',
    fontWeight: 600,
    fontSize: 28,
    margin: 0,
    marginBottom: 24
  },
  theme_card: {
    cursor: 'pointer',
    height: 350,
    backgroundColor: '#FFFFFF',
    borderRadius: 16
  },
  cover_section: {
    height: '170px',
    borderRadius: '16px 16px 0px 0px',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  },
  infos_section: {
    padding: '16px 24px',
    display: 'flex',
    gap: 16,
    flexDirection: 'column',
    '& .title': {
      fontWeight: 600,
      margin: 0,
      fontSize: 20
    }
  },
  overview_wrapper: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  overview_item: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '& .date': {
      backgroundColor: '#D9E8FA80',
      color: '#555555'
    },
    '& .access': {
      backgroundColor: '#E9FAD9',
      color: '#555555'
    },
    '& .classrooms': {
      backgroundColor: '#D2D5D8',
      color: '#555555'
    },
    '& span.label': {
      fontSize: 12,
      fontWeight: 500
    }
  },
  overview_item_value: {
    padding: 8,
    borderRadius: 32,
    height: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .value': {
      fontSize: 12,
      fontWeight: 500
    }
  }
}))

const SocioemotionalSlider = props => {
  const { getThemes, themes, cleanThemes, history } = props
  const classes = useStyles()
  const [isDragging, setIsDragging] = React.useState(false)

  React.useEffect(async () => {
    getThemes({
      params: {
        'page[size]': 8,
        include: 'theme_module.grade.classrooms,cover'
      }
    })
    return () => {
      cleanThemes()
    }
  }, [])

  const handleClickTheme = (e, themeId) => {
    if (isDragging) {
      e.preventDefault()
      e.stopPropagation()
      return
    }
    history.push(`/themes/${themeId}`)
  }

  if (themes?.isFetching) {
    return (
      <div className={classes.slider_root}>
        <CircularProgress />
      </div>
    )
  }
  return (
    <div className={classes.slider_root}>
      <h1 className={classes.title}>Explorando o socioemocional</h1>
      <Slider
        dots
        infinite={false}
        slidesToShow={4}
        slidesToScroll={4}
        adaptiveHeight
        beforeChange={() => setIsDragging(true)}
        afterChange={() => setIsDragging(false)}
        responsive={[
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]}
      >
        {themes.themes?.length > 0 &&
          themes.themes.map(theme => {
            const themeTitle =
              theme.title.length > 50
                ? `${theme.title.slice(0, 50)}...`
                : theme.title
            return (
              <div
                onClick={event => handleClickTheme(event, theme.id)}
                key={theme.id}
                className={classes.theme_card}
              >
                <div
                  className={classes.cover_section}
                  style={{ backgroundImage: `url(${theme.cover.image_url})` }}
                />
                <div className={classes.infos_section}>
                  <h1 className='title'>{themeTitle}</h1>
                  <div className={classes.overview_wrapper}>
                    <div className={classes.overview_item}>
                      <span className='label'>Data:</span>
                      <div className={`${classes.overview_item_value} date`}>
                        <span className='value'>
                          {moment(theme.created_at).format('DD/MM/YYYY')}
                        </span>
                      </div>
                    </div>
                    <div className={classes.overview_item}>
                      <span className='label'>Conteúdos:</span>
                      <div className={`${classes.overview_item_value} access`}>
                        <span className='value'>{theme?.contents?.length}</span>
                      </div>
                    </div>
                    <div className={classes.overview_item}>
                      <span className='label'>Turmas:</span>
                      <div
                        className={`${classes.overview_item_value} classrooms`}
                      >
                        <span className='value'>
                          {theme.theme_module?.grade?.classrooms?.length}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
      </Slider>
    </div>
  )
}

export default SocioemotionalSlider
